import { ReactNode } from 'react';

import clsx from 'clsx';
import { Helmet } from 'react-helmet';

import Footer from '@@/common/components/Footer';
import NavBar from '@@/common/components/NavBar';
import Text from '@@/common/components/Text';
import { useTitleForPartner } from '@@/common/hooks/useTitleForPartner';

import classes from './LayoutSelfService.module.css';

export type TLayoutSelfService = {
  backgroundImgSrc?: string | null;
  children: ReactNode;
  className?: string;
  header?: string | ReactNode;
  isAccountView?: boolean;
  isHideNav?: boolean;
  isLayoutContainer?: boolean;
  metadata?: { title: string; description?: string };
  overrideClasses?: {
    children_container?: string;
    header_container?: string;
    header_content?: string;
    header_greeting?: string;
    root?: string;
  };
  subHeader?: string;
};

function LayoutSelfService({
  backgroundImgSrc,
  children,
  className,
  header,
  isAccountView = false,
  isHideNav = false,
  isLayoutContainer = false,
  metadata,
  overrideClasses,
  subHeader,
}: TLayoutSelfService) {
  const { getTitle } = useTitleForPartner();
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes.layout_container]: isLayoutContainer,
        },
        className,
        overrideClasses?.root
      )}
    >
      {metadata && (
        <Helmet>
          <title>{getTitle(metadata.title)}</title>
          <meta name="description" content={metadata.description} />
        </Helmet>
      )}
      <header
        id="ss_header"
        className={clsx(
          classes.header_container,
          overrideClasses?.header_container
        )}
        style={{
          backgroundImage: backgroundImgSrc
            ? `url(${backgroundImgSrc})`
            : 'none',
        }}
      >
        <div
          className={clsx(
            classes.header_content,
            overrideClasses?.header_content
          )}
        >
          <NavBar
            className={classes.navbar}
            overrideClasses={{
              mobile_nav_cover: classes.mobile_nav_cover,
              root: classes.mobile_nav_ss,
              navbar_temp: classes.mobile_nav_cover,
              logo: classes.mobile_navbar_logo,
            }}
            isHideNavigation={isHideNav}
          />
          {header && (
            <Text
              variant="h4"
              component="h1"
              className={clsx(
                classes.header_greeting,
                overrideClasses?.header_greeting
              )}
              data-testid="self_service_header"
            >
              {header}
            </Text>
          )}
        </div>
      </header>
      <main
        className={clsx(
          classes.children_container,
          overrideClasses?.children_container
        )}
      >
        {subHeader && (
          <Text
            component="h2"
            variant="h3"
            className={classes.subheader}
            data-testid="self_service_subheader"
          >
            {subHeader}
          </Text>
        )}
        {children}
      </main>
      <Footer {...{ isAccountView }} />
    </div>
  );
}

export default LayoutSelfService;
